import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';

import PoolExplain from '@/component/pools/PoolExplain';
import ClaimList from '@/component/pools/ClaimList';
import CommonTop from '@/component/pools/CommonTop';
import UnStakeList from '@/component/pools/UnStakeList';

import { useWeb3 } from '@/hooks/use-web3';
import { GETPOOLDETAILS, PoolState, STATE } from '@/lib/common/name-space';
import { promiseAllSettled } from '@/lib/Promise';

export default function StakeDetail() {
  const {
    state: { contractAddr },
  } = useLocation();

  const [state, setState] = useState('');
  const [title, setTitle] = useState('');
  const { web3authCall } = useWeb3();
  const navigate = useNavigate();

  useEffect(() => {
    if (!contractAddr) {
      // 이전화면으로 이동
      navigate('/portfolio');
      return;
    }
    if (web3authCall?.connected()) {
      (async () => {
        try {
          const re = await promiseAllSettled([
            () => web3authCall.callStaking(STATE, contractAddr),
            () => web3authCall.callStaking(GETPOOLDETAILS, contractAddr),
          ]);
          setState(re[0]);
          setTitle(re[1].name);
        } catch (e) {
          console.error(e);
        }
        // const re = await web3authCall.callStaking(STATE, contractAddr);
        // setState(re);
        // const res = await web3authCall.callStaking(GETPOOLDETAILS, contractAddr);
      })();
    }

    return () => {};
  }, [contractAddr, web3authCall]);

  const TriggerUnStakeList = () => {
    /* UnStaked Section */
    if (state === PoolState.POOLSTATE_FUNDRAISING) {
      return <UnStakeList contractAddr={contractAddr} />;
    }
    return <UnStakeList contractAddr={contractAddr} />;
  };
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', md: '0px' },
        }}
      >
        {/* Portfolio Title Section */}
        <CommonTop
          sx={{
            display: {
              xs: 'none',
              md: 'block',
            },
          }}
          avatar
          title={title}
          subtitle="Pools Of Real-World Assets"
        />

        {/* Portfolio Content Section */}
        <PoolExplain contractAddr={contractAddr} />

        {/* Staked Detail Section */}
        <ClaimList contractAddr={contractAddr} />

        <TriggerUnStakeList />
      </Box>
    </>
  );
}
